import dayJs           from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';

import dayJsIt from 'dayjs/locale/it';

const dateFormat     = 'L';
const hourFormat     = 'LT';
const dateHourFormat = dateFormat + ' ' + hourFormat;

dayJs.extend(LocalizedFormat);
dayJs.locale('it', dayJsIt);

export const formatDateHour = function(value) {
  if (!value) {
    return '';
  }
  
  const parsedDate = dayJs(value);
  const hasHour    = value.split(' ').length === 2;
  
  return parsedDate.format(`L${hasHour ? ' LT' : ''}`);
};

export const formatDate = function(value) {
  if (!value) {
    return '';
  }
  
  const parsedDate = dayJs(value);
  
  return parsedDate.format(`L`);
};

export { dateHourFormat, dateFormat, hourFormat };
